// Trilingual support (Eastern Armenian, Western Armenian, English)
const translations = {
    hy: {
        // App Title
        appTitle: 'Ծրագրային միջերեսների հայերեն թարգմանության հարթակ',
        appSubtitle: 'Կառավարման Համակարգ',
        platformName: 'ԹԱՐԳՄԱՆՉԱԿԱՆ ՊՈՐՏԱԼ',
        
        // Login
        login: 'Մուտք',
        username: 'Օգտանուն',
        password: 'Գաղտնաբառ',
        signIn: 'Մուտք գործել',
        welcome: 'Բարի գալուստ',
        signInDescription: 'Մուտք գործեք ձեր հաշիվ',
        
        // Dashboard
        dashboard: 'Գլխավոր էջ',
        projects: 'Նախագծեր',
        dictionary: 'Բառարան',
        dictionaryDescription: 'Տեխնիկական և տերմինաբանական եզրույթներ՝ Scratch և Snap նախագծերի թարգմանություններից',
        dictionarySearchPlaceholder: 'Որոնել անգլերեն, արևելահայերեն կամ արևմտահայերեն…',
        dictionaryTerms: 'Եզրույթներ',
        dictionaryResults: 'Որոնման արդյունքներ',
        dictionaryNoResults: 'Համընկնում չկա',
        dictionaryEmpty: 'Բառարանի եզրույթներ դեռ չկան',
        dictionaryFilterAll: 'Ամենը',
        dictionaryFilterTechnical: 'Տեխնիկական',
        dictionaryFilterSnap: 'Snap!',
        dictionaryFilterScratch: 'Scratch',
        translations: 'Թարգմանություններ',
        admin: 'Ադմինիստրացիա',
        logout: 'Ելք',
        
        // Roles
        admin: 'Ադմին',
        facilitator: 'Ֆասիլիտատոր',
        translator: 'Թարգմանիչ',
        editor: 'Խմբագիր',
        reviewer: 'Վերանայող',
        confirmer: 'Հաստատող',
        
        // Translation fields
        originalEnglish: 'Անգլերեն',
        originalSource: 'Սկզբնական տեքստ',
        translationText: 'Անգլերեն',
        translation: 'Արևմտահայերեն թարգմանություն',
        editing: 'Խմբագրում',
        review: 'Վերանայում',
        confirmation: 'Հաստատում',
        translator: 'Թարգմանիչ',
        editor: 'Խմբագիր',
        reviewer: 'Վերանայող',
        confirmer: 'Հաստատող',
        facilitatorNotes: 'Ֆասիլիտատորի նշում',
        confirmed: 'Հաստատված',
        westernArmenian: 'Արևմտահայերեն',
        easternArmenian: 'Արևելահայերեն',
        hint: 'Հուշում',
        finalConfirmedWord: 'Վերջնական հաստատված բառը',
        finalApprovedWord: 'Վերջնական հաստատված բառ',
        translation: 'Արևմտահայերեն թարգմանություն',
        suggestions: 'Առաջարկություններ',
        addComment: 'Ավելացնել մեկնաբանութիւն',
        suggestion: 'Առաջարկություն',
        cannotEditConfirmed: 'Հաստատված թարգմանությունը չի կարող խմբագրվել',
        englishRequired: 'Անգլերեն տեքստը պարտադիր է',
        enterEnglishText: 'Մուտքագրեք անգլերեն տեքստ',
        enterWesternArmenian: 'Մուտքագրեք արևմտահայերեն',
        enterEasternArmenian: 'Մուտքագրեք արևելահայերեն',
        enterTranslation: 'Մուտքագրեք թարգմանությունը',
        enterEditing: 'Մուտքագրեք խմբագրությունը',
        pendingTranslation: 'Սպասում է թարգմանության',
        pendingEditing: 'Սպասում է խմբագրման',
        pendingReview: 'Սպասում է վերանայման',
        pendingConfirmation: 'Սպասում է հաստատման',
        allTranslations: 'Բոլոր թարգմանությունները',
        addNewTranslation: 'Ավելացնել նոր թարգմանություն',
        sendToTranslator: 'Ուղարկել թարգմանիչին',
        sendToEditor: 'Ուղարկել խմբագրիչին',
        entrySentToEditor: 'Մուտքագրումը ուղարկված է խմբագրիչին',
        entrySentToReviewer: 'Մուտքագրումը ուղարկված է վերանայողին',
        sendToReviewer: 'Ուղարկել վերանայողին',
        sendToConfirmer: 'Ուղարկել հաստատողին',
        addSuggestionOrComment: 'Ավելացնել առաջարկություն կամ քոմենթ',
        commentRequired: 'Քոմենթը պարտադիր է',
        sentSuccessfully: 'Հաջողությամբ ուղարկված է',
        confirm: 'Հաստատել',
        postpone: 'Հետաձգել',
        confirmed: 'Հաստատված',
        postponed: 'Հետաձգված',
        current: 'Ընթացիկ',
        addComment: 'Ավելացնել մեկնաբանություն',
        comment: 'Մեկնաբանություն',
        pleaseSaveOrClearPreviousComment: 'Խնդրում ենք նախ պահպանել կամ մաքրել նախորդ մեկնաբանությունը',
        back: 'Վերադառնալ',
        
        // Actions
        save: 'Պահպանել',
        cancel: 'Չեղարկել',
        export: 'Արտահանել',
        addNew: 'Ավելացնել նորը',
        edit: 'Խմբագրել',
        options: 'Ընտրանքներ',
        delete: 'Ջնջել',
        deleteEntry: 'Ջնջել մուտքագրումը',
        deleteProject: 'Ջնջել նախագիծը',
        confirmDeleteEntry: 'Հաստատո՞ւմ եք այս թարգմանությունը ջնջելը',
        entryDeleted: 'Թարգմանությունը հաջողությամբ ջնջվեց',
        confirmDeleteProject: 'Հաստատո՞ւմ եք այս նախագիծը ջնջելը',
        projectDeleted: 'Նախագիծը հաջողությամբ ջնջվեց',
        exportToExcel: 'Արտահանել Excel',
        exportSuccess: 'Արտահանումը հաջողությամբ ավարտվեց',
        exportError: 'Սխալ արտահանման ժամանակ',
        create: 'Ստեղծել',
        createProject: 'Ստեղծել նախագիծ',
        projectNameRequired: 'Նախագծի անունը պարտադիր է',
        
        // Messages
        saved: 'Պահպանված է',
        error: 'Սխալ',
        loading: 'Բեռնվում է...',
        noPermission: 'Դուք չունեք թույլտվություն',
        dragDropFile: 'Քաշեք Excel ֆայլը այստեղ',
        orClickToSelect: 'կամ սեղմեք ընտրելու համար',
        clickToChange: 'Սեղմեք փոխելու համար',
        invalidFileType: 'Անվավեր ֆայլի տեսակ: Խնդրում ենք ընտրել .xlsx կամ .xls ֆայլ',
        
        // Status
        active: 'Ակտիվ',
        inactive: 'Անակտիվ',
        pending: 'Սպասման մեջ',
        never: 'Երբեք',
        collapse: 'Ծալել',
        expand: 'Բացել',
        permissions: 'Թույլատրություններ',
        selectRole: 'Ընտրել դեր',
        
        // Additional
        totalProjects: 'Ընդհանուր նախագծեր',
        yourProjects: 'Ձեր նախագծերը',
        viewAll: 'Դիտել բոլորը',
        noProjects: 'Նախագծեր չկան',
        noProjectsDescription: 'Դեռևս նախագծեր չէք ստեղծած',
        createFirst: 'Ստեղծել առաջին նախագիծը',
        lastLogin: 'Վերջին մուտք',
        manageProjects: 'Կառավարեք ձեր թարգմանական նախագծերը',
        allProjects: 'Բոլոր նախագծերը',
        uploadExcel: 'Վերբեռնել Excel ֆայլ',
        startNewProject: 'Սկսեք նոր նախագիծ վերբեռնելով Excel ֆայլ',
        projectName: 'Նախագծի անվանում',
        description: 'Նկարագրություն',
        file: 'Ֆայլ',
        creator: 'Ստեղծող',
        status: 'Կարգավիճակ',
        action: 'Գործողություն',
        name: 'Անվանում',
        
        // Admin Panel
        manageSystem: 'Կառավարեք համակարգը',
        statistics: 'Վիճակագրություն',
        users: 'Օգտատերեր',
        activities: 'Գործողություններ',
        newUser: 'Նոր օգտատեր',
        createUser: 'Ստեղծել նոր օգտատեր',
        create: 'Ստեղծել',
        activityHistory: 'Գործողությունների պատմություն',
        user: 'Օգտատեր',
        details: 'Մանրամասներ',
        date: 'Ամսաթիվ',
        email: 'Էլ. փոստ',
        role: 'Դեր',
        noTranslationsYet: 'Թարգմանություններ դեռ չկան',
        startByAdding: 'Սկսեք ավելացնելով նոր թարգմանություն',
        userCreatedSuccess: 'Օգտատերը հաջողությամբ ստեղծվեց',
        activeUsers: 'Ակտիվ օգտատերեր',

        // Pagination
        showingXtoYofZ: 'Ցուցադրվում է {{from}}–{{to}} {{total}}-ից',
        perPage: 'մեկ էջում',
        page: 'Էջ',
        next: 'Հաջորդ',
        previous: 'Նախորդ',
        entries: 'մուտքագրում',
        selectForExport: 'Ընտրել բառեր արտահանելու համար',
        selectConfirmed: 'Ընտրել հաստատվածները',
        selectAll: 'Ընտրել բոլորը',
        deselectAll: 'Ապակողմնորոշել բոլորը',
        rangeFromId: 'ID՝ ից',
        rangeToId: 'ID՝ մինչև',
        selectByRange: 'Ընտրել միջակայքով',
        selectAtLeastOne: 'Ընտրեք առնվազն մեկ բառ',
        enterValidRange: 'Մուտքագրեք վավեր ID միջակայք',
        noEntriesInRange: 'Նշված միջակայքում բառեր չկան',
        exportSelected: 'Արտահանել ընտրվածները',
        selectedCount: 'Ընտրված'
    },
    hyw: {
        // App Title
        appTitle: 'Ծրագրային միջերեսների հայերէն թարգմանութեան հարթակ',
        appSubtitle: 'Վարչութեան համակարգ',
        platformName: 'ԹԱՐԳՄԱՆԱԿԱՆ ՊՈՐՏԱԼ',
        
        // Login
        login: 'Մուտք',
        username: 'Օգտուողի անուն',
        password: 'Գաղտնաբառ',
        signIn: 'Մուտք գործել',
        welcome: 'Բարի գալուստ',
        signInDescription: 'Մուտք գործեցէք ձեր հաշիւ',
        
        // Dashboard
        dashboard: 'Գլխաւոր էջ',
        projects: 'Նախագծեր',
        dictionary: 'Բառարան',
        dictionaryDescription: 'Տեխնիկական և տերմինաբանական եզրոյթներ՝ Scratch և Snap նախագծերու թարգմանութիւններէն',
        dictionarySearchPlaceholder: 'Որոնել անգլերէն, արևելահայերէն կամ արևմտահայերէն…',
        dictionaryTerms: 'Եզրոյթներ',
        dictionaryResults: 'Որոնման արդիւնքներ',
        dictionaryNoResults: 'Համընկնում չկայ',
        dictionaryEmpty: 'Բառարանի եզրոյթներ դեռ չկան',
        dictionaryFilterAll: 'Ամէնը',
        dictionaryFilterTechnical: 'Տեխնիկական',
        dictionaryFilterSnap: 'Snap!',
        dictionaryFilterScratch: 'Scratch',
        translations: 'Թարգմանութիւններ',
        admin: 'Ադմինիստրացիա',
        logout: 'Ելք',
        
        // Roles
        admin: 'Ադմին',
        facilitator: 'Ֆասիլիտատոր',
        translator: 'Թարգմանիչ',
        editor: 'Խմբագիր',
        reviewer: 'Վերանայող',
        confirmer: 'Հաստատող',
        
        // Translation fields
        originalEnglish: 'Անգլերէն',
        originalSource: 'Սկզբնական տեքստ',
        translationText: 'Անգլերէն',
        translator: 'Թարգմանիչ',
        editor: 'Խմբագիր',
        reviewer: 'Վերանայող',
        confirmer: 'Հաստատող',
        facilitatorNotes: 'Ֆասիլիտատորի նոթեր',
        confirmed: 'Հաստատուած',
        westernArmenian: 'Արևմտահայերէն',
        easternArmenian: 'Արևելահայերէն',
        hint: 'Հուշում',
        finalConfirmedWord: 'Վերջնական հաստատուած բառը',
        finalApprovedWord: 'Վերջնական հաստատուած բառ',
        translation: 'Արևմտահայերէն թարգմանութիւն',
        suggestions: 'Առաջարկութիւններ',
        addComment: 'Ավելացնել մեկնաբանութիւն',
        suggestion: 'Առաջարկութիւն',
        cannotEditConfirmed: 'Հաստատուած թարգմանութիւնը չի կարող խմբագրուել',
        englishRequired: 'Անգլերէն տեքստը պարտադիր է',
        enterEnglishText: 'Մուտքագրեցէք անգլերէն տեքստ',
        enterWesternArmenian: 'Մուտքագրեցէք արևմտահայերէն',
        enterEasternArmenian: 'Մուտքագրեցէք արևելահայերէն',
        enterTranslation: 'Մուտքագրեցէք թարգմանութիւնը',
        enterEditing: 'Մուտքագրեցէք խմբագրութիւնը',
        pendingTranslation: 'Սպասում է թարգմանութեան',
        pendingEditing: 'Սպասում է խմբագրման',
        pendingReview: 'Սպասում է վերանայման',
        pendingConfirmation: 'Սպասում է հաստատման',
        allTranslations: 'Բոլոր թարգմանութիւնները',
        addNewTranslation: 'Ավելացնել նոր թարգմանութիւն',
        sendToTranslator: 'Ուղարկել թարգմանիչին',
        sendToEditor: 'Ուղարկել խմբագրիչին',
        entrySentToEditor: 'Մուտքագրումը ուղարկուած է խմբագրիչին',
        entrySentToReviewer: 'Մուտքագրումը ուղարկուած է վերանայողին',
        sendToReviewer: 'Ուղարկել վերանայողին',
        sendToConfirmer: 'Ուղարկել հաստատողին',
        addSuggestionOrComment: 'Ավելացնել առաջարկութիւն կամ մեկնաբանութիւն',
        commentRequired: 'Մեկնաբանութիւնը պարտադիր է',
        pleaseSaveOrClearPreviousComment: 'Խնդրում ենք նախ պահպանել կամ մաքրել նախորդ մեկնաբանութիւնը',
        sentSuccessfully: 'Հաջողութեամբ ուղարկուած է',
        confirm: 'Հաստատել',
        back: 'Վերադառնալ',
        
        // Actions
        save: 'Պահպանել',
        cancel: 'Չեղարկել',
        export: 'Ֆայլ',
        addNew: 'Ավելացնել նորը',
        edit: 'Խմբագրել',
        options: 'Ընտրանքներ',
        delete: 'Ջնջել',
        deleteEntry: 'Ջնջել մուտքագրումը',
        deleteProject: 'Ջնջել նախագիծը',
        confirmDeleteEntry: 'Հաստատո՞ւմ եք այս թարգմանութիւնը ջնջելը',
        entryDeleted: 'Թարգմանութիւնը հաջողութեամբ ջնջուեց',
        confirmDeleteProject: 'Հաստատո՞ւմ եք այս նախագիծը ջնջելը',
        projectDeleted: 'Նախագիծը հաջողութեամբ ջնջուեց',
        exportToExcel: 'Արտահանել Excel',
        exportSuccess: 'Արտահանումը հաջողութեամբ աւարտուեց',
        exportError: 'Սխալ արտահանման ժամանակ',
        create: 'Ստեղծել',
        createProject: 'Ստեղծել նախագիծ',
        projectNameRequired: 'Նախագծի անունը պարտադիր է',
        
        // Messages
        saved: 'Պահպանուած է',
        error: 'Սխալ',
        loading: 'Բեռնուում է...',
        noPermission: 'Դուք չունէք թոյլտուութիւն',
        dragDropFile: 'Քաշեցէք Excel ֆայլը այստեղ',
        orClickToSelect: 'կամ սեղմեցէք ընտրելու համար',
        clickToChange: 'Սեղմեցէք փոխելու համար',
        invalidFileType: 'Անվաւեր ֆայլի տեսակ: Խնդրում ենք ընտրել .xlsx կամ .xls ֆայլ',
        
        // Status
        active: 'Ակտիւ',
        inactive: 'Անակտիւ',
        pending: 'Առաջընթաց',
        never: 'Երբեք',
        collapse: 'Ծալել',
        expand: 'Բացել',
        permissions: 'Թոյլտուութիւններ',
        selectRole: 'Ընտրել դեր',
        
        // Additional
        totalProjects: 'Ընդհանուր նախագծեր',
        yourProjects: 'Ձեր նախագծերը',
        viewAll: 'Դիտել բոլորը',
        noProjects: 'Նախագծեր չկան',
        noProjectsDescription: 'Դեռեւս նախագծեր չէք ստեղծած',
        createFirst: 'Ստեղծել առաջին նախագիծը',
        lastLogin: 'Վերջին մուտք',
        manageProjects: 'Կառավարեցէք ձեր թարգմանական նախագծերը',
        allProjects: 'Բոլոր նախագծերը',
        uploadExcel: 'Վերբեռնել Excel ֆայլ',
        startNewProject: 'Սկսեցէք նոր նախագիծ վերբեռնելով Excel ֆայլ',
        projectName: 'Նախագծի անվանում',
        description: 'Նկարագրություն',
        file: 'Ֆայլ',
        creator: 'Ստեղծող',
        status: 'Կարգավիճակ',
        action: 'Գործողություն',
        name: 'Անվանում',
        
        // Admin Panel
        manageSystem: 'Կառավարեք համակարգը',
        statistics: 'Վիճակագրություն',
        users: 'Օգտատերեր',
        activities: 'Գործողություններ',
        newUser: 'Նոր օգտատեր',
        createUser: 'Ստեղծել նոր օգտատեր',
        create: 'Ստեղծել',
        activityHistory: 'Գործողությունների պատմություն',
        user: 'Օգտատեր',
        details: 'Մանրամասներ',
        date: 'Ամսաթիվ',
        email: 'Էլ. փոստ',
        role: 'Դեր',
        noTranslationsYet: 'Թարգմանություններ դեռ չկան',
        startByAdding: 'Սկսեք ավելացնելով նոր թարգմանություն',
        userCreatedSuccess: 'Օգտատերը հաջողությամբ ստեղծվեց',
        totalProjects: 'Ընդհանուր նախագծեր',
        activeUsers: 'Ակտիվ օգտատերեր',
        notifications: 'Ծանուցումներ',
        markAllRead: 'Նշել բոլորը որպես կարդացած',
        noNotifications: 'Ծանուցումներ չկան',
        assignUsers: 'Նշանակել օգտատերեր',
        assignUser: 'Նշանակել օգտատեր',
        selectUser: 'Ընտրել օգտատեր',
        assign: 'Նշանակել',
        assignedUsers: 'Նշանակված օգտատերեր',
        noAssignedUsers: 'Նշանակված օգտատերեր չկան',
        confirmRemoveAssignment: 'Հաստատո՞ւմ եք այս նշանակումը հեռացնելը',
        project: 'Նախագիծ',

        // Pagination (hyw)
        showingXtoYofZ: 'Ցուցադրուած է {{from}}–{{to}} {{total}}-ից',
        perPage: 'մէկ էջում',
        page: 'Էջ',
        next: 'Հաջորդ',
        previous: 'Նախորդ',
        entries: 'մուտքագրում',
        selectForExport: 'Ընտրել բառեր արտահանելու համար',
        selectConfirmed: 'Ընտրել հաստատուածները',
        selectAll: 'Ընտրել բոլորը',
        deselectAll: 'Ապակողմնորոշել բոլորը',
        rangeFromId: 'ID՝ ից',
        rangeToId: 'ID՝ մինչեւ',
        selectByRange: 'Ընտրել միջակայքով',
        selectAtLeastOne: 'Ընտրէք առնվազն մէկ բառ',
        enterValidRange: 'Մուտքագրեցէք վաւեր ID միջակայք',
        noEntriesInRange: 'Նշուած միջակայքում բառեր չկան',
        exportSelected: 'Արտահանել ընտրվածները',
        selectedCount: 'Ընտրված'
    },
    en: {
        // App Title
        appTitle: 'Translation Platform',
        appSubtitle: 'Management System',
        platformName: 'TRANSLATION PORTAL',
        
        // Login
        login: 'Login',
        username: 'Username',
        password: 'Password',
        signIn: 'Sign In',
        welcome: 'Welcome',
        signInDescription: 'Sign in to your account',
        
        // Dashboard
        dashboard: 'Dashboard',
        projects: 'Projects',
        dictionary: 'Dictionary',
        dictionaryDescription: 'Technical terms from Scratch and Snap project translations',
        dictionarySearchPlaceholder: 'Search English, Eastern Armenian, or Western Armenian…',
        dictionaryTerms: 'Terms',
        dictionaryResults: 'Search results',
        dictionaryNoResults: 'No matches',
        dictionaryEmpty: 'No dictionary terms yet',
        dictionaryFilterAll: 'All',
        dictionaryFilterTechnical: 'Technical',
        dictionaryFilterSnap: 'Snap!',
        dictionaryFilterScratch: 'Scratch',
        translations: 'Translations',
        admin: 'Administration',
        logout: 'Logout',
        
        // Roles
        admin: 'Admin',
        facilitator: 'Facilitator',
        translator: 'Translator',
        editor: 'Editor',
        reviewer: 'Reviewer',
        confirmer: 'Confirmer',
        
        // Translation fields
        originalEnglish: 'English',
        originalSource: 'Original Source',
        translationText: 'English',
        translator: 'Translator',
        editor: 'Editor',
        reviewer: 'Reviewer',
        confirmer: 'Confirmer',
        facilitatorNotes: 'Facilitator Notes',
        confirmed: 'Confirmed',
        westernArmenian: 'Western Armenian',
        easternArmenian: 'Eastern Armenian',
        hint: 'Hint',
        finalConfirmedWord: 'Final Confirmed Word',
        finalApprovedWord: 'Final Approved Word',
        translation: 'Western Armenian translation',
        suggestions: 'Suggestions',
        addComment: 'Add Comment',
        suggestion: 'Suggestion',
        cannotEditConfirmed: 'Cannot edit confirmed translation',
        englishRequired: 'English text is required',
        enterEnglishText: 'Enter English text',
        enterWesternArmenian: 'Enter Western Armenian',
        enterEasternArmenian: 'Enter Eastern Armenian',
        enterTranslation: 'Enter translation',
        enterEditing: 'Enter editing',
        pendingTranslation: 'Pending Translation',
        pendingEditing: 'Pending Editing',
        pendingReview: 'Pending Review',
        pendingConfirmation: 'Pending Confirmation',
        allTranslations: 'All Translations',
        addNewTranslation: 'Add New Translation',
        sendToTranslator: 'Send to Translator',
        sendToEditor: 'Send to Editor',
        entrySentToEditor: 'Entry has been sent to editor',
        entrySentToReviewer: 'Entry has been sent to reviewer',
        sendToReviewer: 'Send to Reviewer',
        sendToConfirmer: 'Send to Confirmer',
        addSuggestionOrComment: 'Add suggestion or comment',
        commentRequired: 'Comment is required',
        pleaseSaveOrClearPreviousComment: 'Please save or clear the previous comment first',
        sentSuccessfully: 'Sent successfully',
        confirm: 'Confirm',
        back: 'Back',
        
        // Actions
        save: 'Save',
        cancel: 'Cancel',
        export: 'File',
        addNew: 'Add New',
        edit: 'Edit',
        options: 'Options',
        delete: 'Delete',
        deleteEntry: 'Delete Entry',
        deleteProject: 'Delete Project',
        confirmDeleteEntry: 'Are you sure you want to delete this translation entry?',
        entryDeleted: 'Translation entry deleted successfully',
        confirmDeleteProject: 'Are you sure you want to delete this project?',
        projectDeleted: 'Project deleted successfully',
        exportToExcel: 'Export to Excel',
        exportSuccess: 'Export completed successfully',
        exportError: 'Error during export',
        create: 'Create',
        createProject: 'Create Project',
        projectNameRequired: 'Project name is required',
        
        // Messages
        saved: 'Saved',
        error: 'Error',
        loading: 'Loading...',
        noPermission: 'You do not have permission',
        dragDropFile: 'Drag and drop Excel file here',
        orClickToSelect: 'or click to select',
        clickToChange: 'Click to change',
        invalidFileType: 'Invalid file type: Please select .xlsx or .xls file',
        
        // Status
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Progress',
        never: 'Never',
        collapse: 'Collapse',
        expand: 'Expand',
        permissions: 'Permissions',
        selectRole: 'Select Role',
        
        // Additional
        totalProjects: 'Total Projects',
        yourProjects: 'Your Projects',
        viewAll: 'View All',
        noProjects: 'No Projects',
        noProjectsDescription: 'You have not created any projects yet',
        createFirst: 'Create First Project',
        manageProjects: 'Manage your translation projects',
        allProjects: 'All Projects',
        uploadExcel: 'Upload Excel File',
        startNewProject: 'Start a new project by uploading an Excel file',
        projectName: 'Project Name',
        description: 'Description',
        file: 'File',
        creator: 'Creator',
        status: 'Status',
        action: 'Action',
        name: 'Name',
        
        // Admin Panel
        manageSystem: 'Manage the system',
        statistics: 'Statistics',
        users: 'Users',
        activities: 'Activities',
        newUser: 'New User',
        createUser: 'Create New User',
        create: 'Create',
        activityHistory: 'Activity History',
        user: 'User',
        details: 'Details',
        date: 'Date',
        email: 'Email',
        role: 'Role',
        noTranslationsYet: 'No translations yet',
        startByAdding: 'Start by adding a new translation entry',
        userCreatedSuccess: 'User created successfully',
        totalProjects: 'Total Projects',
        activeUsers: 'Active Users',
        notifications: 'Notifications',
        markAllRead: 'Mark all as read',
        noNotifications: 'No notifications',
        assignUsers: 'Assign Users',
        assignUser: 'Assign User',
        selectUser: 'Select User',
        assign: 'Assign',
        assignedUsers: 'Assigned Users',
        noAssignedUsers: 'No assigned users',
        confirmRemoveAssignment: 'Are you sure you want to remove this assignment?',
        project: 'Project',

        // Pagination
        showingXtoYofZ: 'Showing {{from}}–{{to}} of {{total}}',
        perPage: 'per page',
        page: 'Page',
        next: 'Next',
        previous: 'Previous',
        entries: 'entries',
        selectForExport: 'Select entries for export',
        selectConfirmed: 'Select confirmed',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        rangeFromId: 'From ID',
        rangeToId: 'To ID',
        selectByRange: 'Select by range',
        selectAtLeastOne: 'Select at least one entry',
        enterValidRange: 'Enter a valid ID range',
        noEntriesInRange: 'No entries found in that range',
        exportSelected: 'Export selected',
        selectedCount: 'Selected'
    }
};

// Get current language from localStorage or default to Eastern Armenian
export const getLanguage = () => {
    return localStorage.getItem('language') || 'hy';
};

// Set language
export const setLanguage = (lang) => {
    localStorage.setItem('language', lang);
};

// Get translation
export const t = (key) => {
    const lang = getLanguage();
    return translations[lang]?.[key] || key;
};

// Language options
export const languages = [
    { code: 'en', name: 'English', native: 'English' },
    { code: 'hy', name: 'Արևելահայերեն', native: 'Արևելահայերեն' },
    { code: 'hyw', name: 'Արևմտահայերեն', native: 'Արևմտահայերեն' }
];

export default { getLanguage, setLanguage, t, languages };


